<template>
  <div style="height: 200px">
   我要投资页面
    <!-- Employee Area End -->
  </div>
</template>

<script>
  export default {}
</script>




// WEBPACK FOOTER //
// DoInvest.vue?6088a886